module.exports = __webpack_public_path__ + "img/4_127.88b51a40.png";